import React from 'react';
import { Icon } from './Icon.js';
export const IconUserFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("circle", { cx: "6", cy: "2.491", r: "2.5", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("path", { d: "m10.533,8.639c-.932-1.628-2.669-2.639-4.533-2.639s-3.602,1.011-4.533,2.639c-.249.434-.305.954-.154,1.428.15.472.496.863.947,1.072,1.241.574,2.49.861,3.74.861s2.499-.287,3.74-.861h0c.451-.209.796-.6.947-1.072.151-.474.095-.994-.154-1.427Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconUserFill12.js.map